export default {
  googleAuthorizeTerms: "Tämän sovelluksen tuki loppuu 10. maaliskuuta 2023. Asenna sovelluksen {googleAppName} uusi versiomme."
};

// @key: @#@"googleAuthorizeTerms"@#@ @source: @#@"This app will not be supported after Mar 10th, 2023. Please install our new version of {googleAppName}."@#@
